export const SelectedBranchStates = {
    UPDATE: 'Selected_Branch_UPDATE',
    SUCCESS: 'Selected_Branch_SUCCESS',
    FAILED: 'Selected_Branch_FAILED',
    RESET: 'Selected_Branch_RESET',
};
